import { helper as buildHelper } from '@ember/component/helper';

/**
 * @param {{category?: string}[]} options
 * @param {number} currentIndex
 * @returns {boolean}
 */
export const startNewCategory = ([options, currentIndex, hideLabel]) => {
  const currentCategory = options[currentIndex]?.category;
  const previousCategory = options[currentIndex - 1]?.category;

  return currentCategory
    ? (!Boolean(hideLabel) && currentCategory !== previousCategory)
    : false;
};

export default buildHelper(startNewCategory);
